<template>
  <div class="w-100">
    <section>
      <div class="container no-movie-found my-4 d-none d-md-block">
        <div class="row">
          <div class="col-md-3">
            <!-- <img
              src="@/assets/img/backgrounds/popcorn.svg"
              class="img-fluid"
              alt
            /> -->
          </div>
          <div class="col-md-6 text-center">
            <h5 class="title">{{ emptyMessageTitle }}</h5>
            <p class="text" v-html="emptyMessage"></p>
          </div>
          <div class="col-md-3 align-self-end text-center">
            <!-- <img
              src="@/assets/img/backgrounds/babycorn.svg"
              class="img-fluid"
              alt
            /> -->
          </div>
        </div>
      </div>

      <!-- MOBILE SITE -->
      <div class="container my-4 d-md-none">
        <div class="no-movie-found">
          <div class="row pt-5">
            <div class="col-3">
              <!-- <img
                src="@/assets/img/backgrounds/popcorn.svg"
                class="img-fluid"
                alt
              /> -->
            </div>
            <div class="col-6 text-center align-self-end">
              <h5 class="title">{{ emptyMessageTitle }}</h5>
            </div>
            <div class="col-3 align-self-end">
              <!-- <img
                src="@/assets/img/backgrounds/babycorn.svg"
                class="img-fluid"
                alt
              /> -->
            </div>
          </div>
        </div>

        <p class="text" v-html="emptyMessage"></p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    isClass: {
      type: String,
      default: ""
    },
    emptyMessageTitle: {
      type: String,
      default: ""
    },
    emptyMessage: {
      type: String,
      default: `No Movies Found`
    },
    isNeedTopSpace: {
      type: Boolean,
      default: false
    },
    emptyImage: {
      type: String,
      default: require("@/assets/img/backgrounds/popcorn.svg")
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/common/EmptyMovieState.vue